import { ReactNode } from "react";

import { useDropdownContext } from "@/components/General/Dropdown/context/dropdown.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type LabelProps = {
    children?: ReactNode;
};

export const Label = ({ children }: LabelProps) => {
    const { t } = useGranite();

    const { label, isLabel } = useDropdownContext();

    return (isLabel && label) || children || t("general.dropdown.placeholder");
};
